import { render, staticRenderFns } from "./UserLibrariesTab.vue?vue&type=template&id=7feea0b8&scoped=true"
import script from "./UserLibrariesTab.vue?vue&type=script&lang=js"
export * from "./UserLibrariesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7feea0b8",
  null
  
)

export default component.exports